<div class="ms-xxsmall-b accommodate-icon">
  <h3 class="ms-small-l ms-xxsmall-b medium-type font-body-1">{{ 'MMB.labels.eticketNumber' | finLocalization }}</h3>
  <ul class="ms-small-l no-list-style">
    <li *ngFor="let ticket of tickets; last as isLastTicket" [class.ms-xxsmall-b]="!isLastTicket">
      {{ ticket.id }}
    </li>
  </ul>
  <p class="ms-small-l font-body-2 nordic-blue-900-text">
    {{ 'MMB.labels.eticketNumberHelp' | finLocalization }}
  </p>
</div>
